module.exports = __webpack_public_path__ + "gfx/VST-892HD.png";